//var isWalletConnected = false; // This shows wether the user's wallet is connected or not. 
// For other modules to check if wallet is connected in the first loading second, there may be need to have a async function to return the value
// Here:
async function isWalletConnected() {
      return false// Its false now but will be dynamic after integration
}
export default isWalletConnected